import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
	selector: 'app-kamona-switch',
	templateUrl: './kamona-switch.component.html',
	styleUrls: ['./kamona-switch.component.scss']
})
export class KamonaSwitchComponent implements OnInit {
	@Input() value: boolean;
	@Input() disable: boolean;
	@Input() showLabel: boolean;
	@Input() onLabel: string;
	@Input() offLabel: string;
	@Output() changed = new EventEmitter();

	constructor() {
	}

	emitChange($event) {
		this.changed.emit($event);
	}

	ngOnInit(): void {
		if (this.disable) {
			this.value = false;
		}
	}

}
